import { render } from "./masterList.vue?vue&type=template&id=61f97bce"
import script from "./masterList.vue?vue&type=script&lang=js"
export * from "./masterList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__